import { Podcast, Episode, EmailRevealLog } from "@/types/podcast";

export function mapUsageLogFromApi(data: any): EmailRevealLog {
    return {
        id: data.id || `log-${Date.now()}-${Math.random()}`, // Fallback ID if missing
        type: data.type || 'REVEAL', // Default to reveal if missing
        description: data.description || data.podcastTitle || data.podcast_title || 'Unknown Action',
        imageUrl: data.imageUrl || data.image_url || data.podcastImage || data.podcast_image || '',
        amount: data.amount || 1, // Usually 1 credit per reveal
        date: data.date || data.createdAt || data.created_at || new Date().toISOString(),
        referenceId: data.referenceId || data.reference_id || data.podcastId || data.podcast_id,
        creditSource: data.creditSource || data.credit_source
    };
}

export function mapEpisodeFromApi(data: any): Episode {
    return {
        id: data.id,
        guid: data.guid,
        title: data.title,
        description: data.description,
        summary: data.summary,
        publishedAt: data.published_at || data.publishedAt || data.publish_date || data.pubDate,
        durationSeconds: data.duration_seconds || data.durationSeconds || data.duration,
        durationFormatted: data.duration_formatted || data.durationFormatted,
        episodeNumber: data.episode_number || data.episodeNumber,
        seasonNumber: data.season_number || data.seasonNumber,
        episodeType: data.episode_type || data.episodeType,
        explicit: data.explicit,
        enclosureUrl: data.enclosure_url || data.enclosureUrl || data.audio_url || data.url,
        enclosureType: data.enclosure_type || data.enclosureType,
        imageUrl: data.image_url || data.imageUrl,
        link: data.link
    };
}

export function mapPodcastFromApi(data: any): Podcast {
  return {
    id: data.id,
    title: data.title,
    description: data.description,
    author: data.author || data.publisher, // Handle potential field name differences
    imageUrl: data.image_url || data.imageUrl,
    thumbnailUrl: data.thumbnail_url || data.thumbnailUrl,
    language: data.language,
    episodeCount: data.episode_count || data.total_episodes || data.episodeCount || 0,
    lastEpisodeDate: data.newest_item_publish_time || data.lastEpisodeDate || data.latest_episode_date,
    hasEmail: data.has_email || data.hasEmail || (typeof data.owner_email === 'string' && data.owner_email.length > 0) || !!data.email,
    email: data.owner_email || data.email, // Store the email string if available (for details page)
    website: data.website_url || data.website,
    url: data.url,
    itunesId: data.itunes_id || data.itunesId,
    isExplicit: data.explicit || data.isExplicit,
    appleRating: data.apple_rating || data.appleRating,
    appleRatingCount: data.review_count || data.appleRatingCount,
    popularityScore: data.popularity_score || data.popularityScore,
    estimatedListeners: data.estimated_listeners || data.estimatedListeners || 0,
    externalLinks: data.externalLinks || data.external_links,
    matchedEpisodes: data.matchedEpisodes ? data.matchedEpisodes.map(mapEpisodeFromApi) : undefined,
    
    // Youtube Stats
    youtubeHandle: data.youtubeHandle || data.youtube_handle,
    youtubeSubscriberCount: data.youtubeSubscriberCount || data.youtube_subscriber_count,
    youtubeVideoCount: data.youtubeVideoCount || data.youtube_video_count,
    youtubeUrl: data.youtubeUrl || data.youtube_url,
    youtubeUpdatedAt: data.youtubeUpdatedAt || data.youtube_updated_at,

    // Regional ratings
    primaryMarket: data.primaryMarket || data.primary_market,
    regionalRatings: data.regionalRatings || data.regional_ratings,
  };
}
